import React, { useState, useEffect } from "react";
import { Box, Grid, TextField, Alert, Snackbar, Button } from "@mui/material";
import MainDashboardLayout from "../../../../Layout/MainDashboardLayout";
import GRISidebar from "../../../../Layout/GRISidebar";
import styles from "../../../../styles/gri/general.module.css";
import DynamicTable from "../../../../Components/Common/DynamicTable";
import { restructureData } from "../../../../utils/restructureData";
import EastIcon from "@mui/icons-material/East";
import { put, get } from "../../../../utils/api";
import { useNavigate, useParams } from "react-router-dom";
import ReviewBox from "../../../../Components/Common/ReviewBox";

import { currentYear } from "../../../../utils/generateYearRanges";
import SectionHeading from "../../GRI300/GRI308/SectionHeading";

const GRI403_10 = ({ hide, downloadMode = false }) => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [disabled, setDisabled] = useState(false);
  const [data, setData] = useState({});
  const [griReview, setGriReview] = useState(() => JSON.parse(localStorage.getItem("griReview")));

  const fields = [
    {
      id: 1,
      title:
        "i. The number of fatalities as a result of work-related ill health",
      text: [
        "No of fatalities as a result of work-related ill health",
        "Remark",
      ],
      keys: ["fatalitiesRateWorkRelated", "remarkFatalities"],
      types: ["number", "text"],
    },
    {
      id: 2,
      title: "ii. The number of cases of recordable work-related ill health",
      text: ["No of cases of recordable work-related ill health", "Remark"],
      keys: ["recordableWorkHealth", "remarkrecordableWorkHealth"],
      types: ["number", "text"],
    },
  ];

  const workplacefields = [
    {
      id: 1,
      title:
        "i. The number of fatalities as a result of work-related ill health",
      text: [
        "No of fatalities as a result of work-related ill health",
        "Remark",
      ],
      keys: ["nunberRateFatalites", "fatalitiesAsRemark"],
      types: ["number", "text"],
    },
    {
      id: 2,
      title: "ii. The number of cases of recordable work-related ill health",
      text: ["No of cases of recordable work-related ill health", "Remark"],
      keys: ["workplacerecordableWorkHealth", "workplaceWorkHealth"],
      types: ["number", "text"],
    },
  ];

  const inputData = [
    {
      fieldName: "controlledByOrg",
      title: "iii. The main types of work-related ill health",
      fields: [
        {
          fieldName: "health",
          title: "Type of work-related ill health",
          type: "text",
          placeholder: "Type Here",
        },
      ],
    },
  ];

  const inputData1 = [
    {
      fieldName: "controlledByOrg",
      title: "iii. The main types of work-related ill health",
      fields: [
        {
          fieldName: "health",
          title: "Type of work-related ill health",
          type: "text",
          placeholder: "Type Here",
        },
      ],
    },
  ];

  const inputData2 = [
    {
      fieldName: "hierachyOfControls",
      title:
        "iii. Actions taken or underway to eliminate these hazards and minimize risks using the hierarchy of controls.",
      fields: [
        {
          fieldName: "action",
          title: "Action",
          type: "text",
          placeholder: "Type Here",
        },
      ],
    },
  ];

  const [tables, setTables] = React.useState([]);
  const [tabErrors, setTabErrors] = useState({});

  const [tables1, setTables1] = React.useState([]);
  const [tabErrors1, setTabErrors1] = useState({});

  const [tables2, setTables2] = React.useState([]);
  const [tabErrors2, setTabErrors2] = useState({});

  const [formData, setFormData] = useState({
    determined: "",
    highConsequence: "",
    hazardsAndMinizeRisk: "",
    contextualInformation: "",
  });

  const [employeeData, setEmployeeData] = useState({
    fatalitiesRateWorkRelated: "",
    remarkFatalities: "",
    recordableWorkHealth: "",
    remarkrecordableWorkHealth: "",
  });

  const [workplaceData, setWorkplaceData] = useState({
    nunberRateFatalites: "",
    fatalitiesAsRemark: "",
    workplacerecordableWorkHealth: "",
    workplaceWorkHealth: "",
  });

  const [snackOpen, setSnackOpen] = useState({
    open: false,
    message: "",
    severity: "",
  });

  const handleChange = (e, fieldKey) => {
    setEmployeeData((prevData) => ({
      ...prevData,
      [fieldKey]: e.target.value,
    }));
  };

  const handleChangeworkplace = (e, fieldKey) => {
    setWorkplaceData((prevData) => ({
      ...prevData,
      [fieldKey]: e.target.value,
    }));
  };

  const handleFieldChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value, // Dynamically update the matching field
    }));
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await get(`/gri/get?type=GRI400&Id=${id}`);
        if (response?.data?.data?.year < currentYear - 1) setDisabled(true);

        const data1 = response.data.data.GRI400.workedRelatedIllHealth || {};
        setData(data1);
        setFormData({
          determined: data1?.workHazards?.determined || "",
          highConsequence: data1?.workHazards?.highConsequence || "",
          hazardsAndMinizeRisk: data1?.hazardsAndMinizeRisk || "",
          contextualInformation: data1?.contextualInformation || "",
        });
        setEmployeeData({
          fatalitiesRateWorkRelated:
            data1?.forAllEmployees?.fatalitiesRateWorkRelated || "",
          remarkFatalities: data1?.forAllEmployees?.remarkFatalities || "",
          recordableWorkHealth:
            data1?.forAllEmployees?.recordableWorkHealth || "",
          remarkrecordableWorkHealth:
            data1?.forAllEmployees?.remarkrecordableWorkHealth || "",
        });
        setWorkplaceData({
          nunberRateFatalites:
            data1?.workplaceController?.nunberRateFatalites || "",
          fatalitiesAsRemark:
            data1?.workplaceController?.fatalitiesAsRemark || "",
          workplacerecordableWorkHealth:
            data1?.workplaceController?.workplacerecordableWorkHealth || "",
          workplaceWorkHealth:
            data1?.workplaceController?.workplaceWorkHealth || "",
        });
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  const handleSubmit = async () => {
    if (!disabled) {
      // const isTableValid = validateTable(inputData, tables, setTabErrors);
      // const isTableValid1 = validateTable(inputData1, tables1, setTabErrors1);
      // const isTableValid2 = validateTable(inputData2, tables2, setTabErrors2);

      // if (!isTableValid || !isTableValid1 || !isTableValid2) {
      //   return;
      // }

      let transformedData = restructureData(tables);
      let transformedData1 = restructureData(tables1);
      let transformedData2 = restructureData(tables2);

      const payload = {
        type: "GRI400",
        submitted403_10: true,
        workedRelatedIllHealth: {
          forAllEmployees: {
            ...employeeData,
            ...transformedData,
          },
          workplaceController: {
            ...workplaceData,
            ...transformedData1,
          },
          workHazards: {
            determined: formData.determined,
            highConsequence: formData.highConsequence,
            ...transformedData2,
          },
          hazardsAndMinizeRisk: formData.hazardsAndMinizeRisk,
          contextualInformation: formData.contextualInformation,
        },
      };

      try {
        const token = sessionStorage.getItem("token");
        if (!token) {
          throw new Error("Authentication token is missing.");
        }
        await put(`/gri/update?Id=${id}`, payload);
        navigate(`/gri/gri400/404-1/${id}`);
      } catch (error) {
        setSnackOpen({
          open: true,
          message: "Error updating data. Please try again.",
          severity: "error",
        });
      }
    } else {
      navigate(`/gri/gri400/404-1/${id}`);
    }
  };

  const renderContent = ({ hide }) => (
    <>
      {!hide && (
        <p className={styles.section_heading}>
          403 : Occupational Health and Safety
        </p>
      )}
      <p
        className={styles.main_heading}
        style={{ marginBottom: hide ? "-1rem" : "0" }}
      >
        403-10 : Work-related ill health
      </p>
      <Box sx={{ display: "flex", flexDirection: "column" }}>
        <SectionHeading
          text="a. For all employees"
          sx={{ marginBottom: "-0.5rem" }}
        />
        {fields.map((field) => (
          <Box key={field.id} sx={{ mt: 1, marginLeft: "1rem" }}>
            <p variant="subtitle1" className={styles.ques_heading}>
              {field.title}
            </p>
            <Grid container spacing={2} sx={{ marginLeft: "0.2rem" }}>
              {field.text.map((text, index) => (
                <Grid item xs={12} sm={index === 2 ? 3.3 : 4.6} key={index}>
                  <p style={{ fontSize: "14px", marginTop: "-0.5rem" }}>
                    {text}
                  </p>
                  <TextField
                    fullWidth
                    placeholder="Type here"
                    variant="outlined"
                    type={field.types[index]}
                    sx={{
                      marginTop: "-0.5rem",
                      "& .MuiOutlinedInput-root": {
                        height: "2.5rem",
                      },
                      "& input[type=number]": {
                        MozAppearance: "textfield",
                      },
                      "& input[type=number]::-webkit-outer-spin-button, & input[type=number]::-webkit-inner-spin-button":
                        {
                          WebkitAppearance: "none",
                          margin: 0,
                        },
                    }}
                    // onChange={(e) => handleChange(e, field.keys[index])}
                    value={employeeData[field.keys[index]] || ""}
                    onChange={(e) => handleChange(e, field.keys[index])}
                    onKeyPress={(e) => {
                      if (
                        field.types[index] === "number" &&
                        (e.key === "-" || e.key === "e")
                      ) {
                        e.preventDefault(); // Prevent negative and exponential input
                      }
                    }}
                    inputProps={{
                      inputMode: "numeric",
                      pattern: "[0-9]*",
                      onWheel: (e) => e.target.blur(), // Prevent scrolling from changing the value
                    }}
                    disabled={disabled}
                  />
                </Grid>
              ))}
            </Grid>
          </Box>
        ))}
      </Box>

      <Box sx={{ marginLeft: "1rem" }}>
        <DynamicTable
          inputData={inputData}
          tables={tables}
          setTables={setTables}
          data={data?.forAllEmployees}
          errors={tabErrors}
          setErrors={setTabErrors}
          disabled={disabled}
          hide={hide}
        />
      </Box>
      {/* section B */}
      {downloadMode && <Box sx={{ pageBreakBefore: "always" }}></Box>}
      <Box sx={{ display: "flex", flexDirection: "column" }}>
        <SectionHeading
          text="b. For all workers who are not employees but whose work and/or workplace is controlled by the organization"
          sx={{ marginBottom: "-0.5rem" }}
        />
        {workplacefields.map((field) => (
          <Box key={field.id} sx={{ mt: 1, marginLeft: "1rem" }}>
            <p variant="subtitle1" className={styles.ques_heading}>
              {field.title}
            </p>
            <Grid container spacing={2} sx={{ marginLeft: "0.2rem" }}>
              {field.text.map((text, index) => (
                <Grid item xs={12} sm={index === 2 ? 3.3 : 4.6} key={index}>
                  <p style={{ fontSize: "14px", marginTop: "-0.5rem" }}>
                    {text}
                  </p>
                  <TextField
                    fullWidth
                    placeholder="Type here"
                    variant="outlined"
                    disabled={disabled}
                    type={field.types[index]}
                    sx={{
                      marginTop: "-0.5rem",
                      "& .MuiOutlinedInput-root": {
                        height: "2.5rem",
                      },
                      "& input[type=number]": {
                        MozAppearance: "textfield",
                      },
                      "& input[type=number]::-webkit-outer-spin-button, & input[type=number]::-webkit-inner-spin-button":
                        {
                          WebkitAppearance: "none",
                          margin: 0,
                        },
                    }}
                    value={workplaceData[field.keys[index]] || ""}
                    onChange={(e) =>
                      handleChangeworkplace(e, field.keys[index])
                    }
                    onKeyPress={(e) => {
                      if (
                        field.types[index] === "number" &&
                        (e.key === "-" || e.key === "e")
                      ) {
                        e.preventDefault(); // Prevent negative and exponential input
                      }
                    }}
                    inputProps={{
                      inputMode: "numeric",
                      pattern: "[0-9]*",
                      onWheel: (e) => e.target.blur(), // Prevent scrolling from changing the value
                    }}
                  />
                </Grid>
              ))}
            </Grid>
          </Box>
        ))}
      </Box>

      <Box sx={{ marginLeft: "1rem" }}>
        <DynamicTable
          inputData={inputData1}
          tables={tables1}
          data={data?.workplaceController}
          setTables={setTables1}
          errors={tabErrors1}
          setErrors={setTabErrors1}
          disabled={disabled}
          hide={hide}
        />
      </Box>

      {/* SectionC */}
      {downloadMode && <Box sx={{ pageBreakBefore: "always" }}></Box>}
      <Box>
        <SectionHeading
          text="c. The work-related hazards that pose a risk of ill health, including:"
          sx={{ marginBottom: "-0.1rem" }}
        />
        <Box sx={{ marginLeft: "1rem" }}>
          <SectionHeading text="i. How does these hazards have been determined" />
          <TextField
            fullWidth
            placeholder="Type Here"
            variant="outlined"
            multiline
            disabled={disabled}
            minRows={1}
            sx={{
              marginLeft: "1rem",
              marginTop: "-0.5rem",
              "& .MuiOutlinedInput-root": {
                padding: "10px",
                display: "flex", // Ensures proper alignment
              },
              "& .MuiInputBase-root": {
                overflow: "hidden", // Prevents text from overflowing
              },
              "& textarea": {
                resize: "none", // Prevents manual resizing to keep it controlled
              },
            }}
            value={formData.determined}
            name="determined"
            onChange={handleFieldChange}
          />

          <SectionHeading text="ii. Which of these hazards have caused or contributed to cases of ill health during the reporting period;" />
          <TextField
            fullWidth
            placeholder="Type Here"
            variant="outlined"
            multiline
            disabled={disabled}
            minRows={1}
            sx={{
              marginLeft: "1rem",
              marginTop: "-0.5rem",
              "& .MuiOutlinedInput-root": {
                padding: "10px",
                display: "flex", // Ensures proper alignment
              },
              "& .MuiInputBase-root": {
                overflow: "hidden", // Prevents text from overflowing
              },
              "& textarea": {
                resize: "none", // Prevents manual resizing to keep it controlled
              },
            }}
            value={formData.highConsequence}
            name="highConsequence"
            onChange={handleFieldChange}
          />

          <DynamicTable
            inputData={inputData2}
            tables={tables2}
            setTables={setTables2}
            data={data?.workHazards}
            errors={tabErrors2}
            setErrors={setTabErrors2}
            disabled={disabled}
            hide={hide}
          />
        </Box>
      </Box>

      {/* D,E,F,G */}
      {downloadMode && <Box sx={{ pageBreakBefore: "always" }}></Box>}
      <Box>
        {/* Question D */}
        <Box>
          <SectionHeading text="d. Whether and, if so, why any workers have been excluded from this disclosure, including the types of worker excluded." />
          <TextField
            fullWidth
            placeholder="Type Here"
            variant="outlined"
            multiline
            minRows={1}
            disabled={disabled}
            sx={{
              marginLeft: "1rem",
              marginTop: "-0.5rem",
              "& .MuiOutlinedInput-root": {
                padding: "10px",
                display: "flex", // Ensures proper alignment
              },
              "& .MuiInputBase-root": {
                overflow: "hidden", // Prevents text from overflowing
              },
              "& textarea": {
                resize: "none", // Prevents manual resizing to keep it controlled
              },
            }}
            value={formData.hazardsAndMinizeRisk}
            name="hazardsAndMinizeRisk"
            onChange={handleFieldChange}
          />
        </Box>

        {/* Question E */}
        <Box>
          <SectionHeading text="e. Any contextual information necessary to understand how the data have been compiled, such as any standards, methodologies, and assumptions used." />
          <TextField
            fullWidth
            placeholder="Type Here"
            name="contextualInformation"
            variant="outlined"
            value={formData.contextualInformation}
            multiline
            minRows={1}
            disabled={disabled}
            sx={{
              marginLeft: "1rem",
              marginTop: "-0.5rem",
              "& .MuiOutlinedInput-root": {
                padding: "10px",
                display: "flex", // Ensures proper alignment
              },
              "& .MuiInputBase-root": {
                overflow: "hidden", // Prevents text from overflowing
              },
              "& textarea": {
                resize: "none", // Prevents manual resizing to keep it controlled
              },
            }}
            onChange={handleFieldChange}
          />
        </Box>

        {/* Snackbar for success/error messages */}
        <Snackbar
          open={snackOpen.open}
          message={snackOpen.message}
          autoHideDuration={3000}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          onClose={() => setSnackOpen({ ...snackOpen, open: false })}
        >
          <Alert
            severity={snackOpen.severity}
            variant="filled"
            sx={{ width: "100%" }}
          >
            {snackOpen.message}
          </Alert>
        </Snackbar>
      </Box>
    </>
  );

  return (
    <>
      {!hide ? (
        <MainDashboardLayout sidebar={<GRISidebar />}>
          {renderContent({ hide })}

          <>
            {!griReview ? (
              <Box sx={{ ml: "1rem", width: "98%" }}>
                <ReviewBox url={"/gri"} handleSubmit={handleSubmit} />
              </Box>
            ) : (
              <Box textAlign="right" sx={{ mt: 3 }}>
                <Button
                  variant="contained"
                  sx={{
                    bgcolor: "#1C486B",
                    textTransform: "none",
                    mt: 3,
                    mb: 5,
                  }}
                  onClick={handleSubmit}
                >
                  Save & Continue <EastIcon sx={{ ml: 2 }} />
                </Button>
              </Box>
            )}
          </>
        </MainDashboardLayout>
      ) : (
        renderContent({ hide })
      )}
    </>
  );
};

export default GRI403_10;
